import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStageIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("circle", {
			fill: "#5649BE",
			cx: 16,
			cy: 16,
			r: 16
		}), /* @__PURE__ */ _jsx("path", {
			d: "M9.922 10.667h10.396c.133 0 .254.073.315.19l2.614 4.978a.356.356 0 0 1 0 .33l-2.614 4.978a.356.356 0 0 1-.315.19H9.922a.356.356 0 0 1-.315-.52l2.44-4.648a.356.356 0 0 0 0-.33l-2.44-4.648a.356.356 0 0 1 .315-.52z",
			fill: "#FFF"
		})]
	})
});
export default SvgStageIcon;
